import { Button, Paper, Stack, styled, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import SuccessImg from 'assets/success_img.png';

const RegisterSuccessPage = () => {
  const navigate = useNavigate();

  const goToHome = () => {
    navigate('/');
  };

  return (
    <PaperStyled>
      <StackStyled spacing={2}>
        <img alt="success-img" src={SuccessImg} height="160" width="160" />
        <Typography color="surface.700" variant="h4">
          Aplikasi Dikirim
        </Typography>
        <Typography color="surface.700" align="center" maxWidth="604px">
          Terimakasih telah menyelesaikan pengajuan pembukaan rekening Giro BSS. Pastikan pengurus anda hadir pada sesi
          video call yang telah dijadwalkan.
        </Typography>
        <Button variant="contained" sx={{ maxWidth: 200 }} onClick={goToHome}>
          Kembali ke Beranda
        </Button>
      </StackStyled>
    </PaperStyled>
  );
};

const PaperStyled = styled(Paper)(({ theme }) => ({
  width: '100%',
  padding: theme.spacing(3)
}));

const StackStyled = styled(Stack)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}));

export default RegisterSuccessPage;
